import React, { useState, useEffect } from 'react';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import Botonsubseccion from './Componentes/BotonSubseccion';
import { activeDialog } from '../../../../../utils/Common';
import Post from '../../../../../utils/Post';
import EditorValvula from './Componentes/EditorValvula';
import EditorRancho from './Componentes/EditorRancho';
import CloseButton from '../../../../sharecomponents/CloseButton';

const CatalogoValvulas = () => {
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [datos, setdatos] = useState({ valvulas: [], ranchos: [] });
    const [galeriaFiltrosAbierta, setgaleriaFiltrosAbierta] = useState(false);
    const [filtrosValulas, setfiltrosValulas] = useState({
        electrificada: { opciones: ["SI", "NO"], seleccion: "" },
        hoops: { opciones: ["SI", "NO"], seleccion: "" },
        micro: { opciones: ["SI", "NO"], seleccion: "" },
        sombra: { opciones: ["SI", "NO"], seleccion: "" },
        sombra: { opciones: ["SI", "NO"], seleccion: "" },
        tipo_agua: { opciones: ["SIN RO, NO", "RO"], seleccion: "" },
        rancho: { opciones: [], seleccion: "" }
    });
    const [valulasSinFiltro, setvalulasSinFiltro] = useState([]);
    const [section, setsection] = useState("valvulas");
    const [edit, setedit] = useState(null);
    const keys = {
        valvulas: [
            { key: 'codigo', name: 'CODIGO' },
            { key: 'codigo2', name: 'COD. ALTERNO' },
            { key: 'rancho_nombre', name: 'RANCHO' },
            { key: 'largo', name: 'LARGO CAMA' },
            { key: 'no_camas', name: 'NUM. CAMAS' },
            { key: 'micro', name: 'MICROASPERSIÓN' },
            { key: 'electrificada', name: 'ELECTRIFICADA' },
            { key: 'hoops', name: 'HOOPS' },
            { key: 'sombra', name: 'SOMBRA' },
            { key: 'totalm2', name: 'METROS2 TOTALES' },
            { key: 'tipo_agua', name: 'TIPO DE AGUA' },
        ],
        ranchos: [
            { key: 'nombre', name: 'NOMBRE' },
            { key: 'metros', name: 'METROS2 TOTALES' },
            { key: 'camas', name: 'NÚM. CAMAS' },
            { key: "valvulas", name: "VALVULAS" }
        ]
    };
    useEffect(() => { getData() }, []);

    const getAPI = async (data, uri) => {
        let resp = await Post(uri, data, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Ocurrrió un problema');
            return false;
        }
        return resp.data;
    }

    const getData = async () => {
        let resp = await getAPI({}, 'catalogos/valvulas/get');
        if (resp) {
            setdatos(resp);
            setvalulasSinFiltro(resp.valvulas);
            setfiltrosValulas(prev => ({ ...prev, rancho: { ...prev.rancho, opciones: resp.ranchos.map(r => r.nombre?.toUpperCase()) } }));
        }
    }

    const filtrarValvulas = (filtroNombre, valor) => {
        let valvulas_filtradas = [];
        const fs = { ...filtrosValulas, [filtroNombre]: { ...filtrosValulas[filtroNombre], seleccion: valor } };
        valulasSinFiltro.forEach(val => {
            if (fs.electrificada.seleccion !== "" && !fs.electrificada.seleccion.includes(val.electrificada)) return;
            if (fs.hoops.seleccion !== "" && !fs.hoops.seleccion.includes(val.hoops)) return;
            if (fs.micro.seleccion !== "" && !fs.micro.seleccion.includes(val.micro)) return;
            if (fs.sombra.seleccion !== "" && !fs.sombra.seleccion.includes(val.sombra)) return;
            if (fs.tipo_agua.seleccion !== "" && !fs.tipo_agua.seleccion.includes(val.tipo_agua)) return;
            if (fs.rancho.seleccion !== "" && !fs.rancho.seleccion.includes(val.rancho_nombre?.toUpperCase())) return;
            valvulas_filtradas.push(val);
        });
        setfiltrosValulas(fs);
        setdatos(prev => ({ ...prev, valvulas: valvulas_filtradas }));
    }


    return (
        <>
            <div className='w-100 overflow bg-white m-0 p-1 overflow relative border round-m shadow-sm dosis' style={{ height: "calc(100vh - 60px)" }}>

                <div className='row justify-content-evenly w-100 m-0 p-0'>
                    <div className='w-100 p-1 bg-orange-900 ps-2 text-white text-xl round-top-m mb-2' style={{ position: "sticky", top: 0, left: 0, zIndex: 2 }}>Catálogo de válvulas y ranchos</div>
                    <div className='bw-200 contenedor'>
                        <button className='btn btn-light border border-info btn-sm shadow' onClick={() => setgaleriaFiltrosAbierta(true)}>FILTROS VÁLVULAS</button>
                    </div>
                    <Botonsubseccion action={() => setsection('valvulas')} name="valvulas" isSelected={section === "valvulas"} helpText={`(${datos.valvulas.length})`} />
                    <Botonsubseccion action={() => setsection('ranchos')} name="ranchos" isSelected={section === "ranchos"} helpText={`(${datos.ranchos.length})`} />
                    <div className='bw-400 contenedor'>
                        <button className='btn btn-light btn-sm round-xxl shadow border border-2 border-warning text-bold' onClick={() => setedit({})}>
                            {section === "valvulas" ? "AGREGAR VALVULA" : "AGREGAR RANCHO"}
                        </button>
                    </div>
                    <div className='w-100 mt-1'></div>
                    <div className='bw-1200 bg-white shadow-multi round-m overflow' style={{ maxHeight: "80vh" }}>
                        <table className='table table-sm table-striped table-hover'>
                            <thead>
                                <tr>
                                    {keys[section].map((k, i) => <th key={i} scope='col' className='text-center text-m'>{k.name}</th>)}

                                </tr>
                            </thead>
                            <tbody>
                                {datos[section].map((d, i) =>
                                    <tr key={i + "erfd"} className='pointer nowrap' onClick={() => setedit(d)}>
                                        {keys[section].map((k, j) => <td key={j + "ddd" + i} className='text-center nowrap'>{d[k.key]}</td>)}
                                    </tr>
                                )}
                                {section === "valvulas" && <tr>
                                    <td className="text-center text-bold ">TOTALES</td>
                                    <td colSpan={3}></td>
                                    <td className='text-center border-top border-dark fw-bold text-m'>{datos.valvulas.reduce((acc, val) => acc + val.no_camas, 0)}</td>
                                    <td colSpan={4}></td>
                                    <td className='text-center border-top border-dark fw-bold text-m'>{datos.valvulas.reduce((acc, val) => acc + val.totalm2, 0)}</td>
                                    <td></td>
                                </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
                {loader && ldr}

                {edit && section === "valvulas" && <EditorValvula data={edit} ranchos={datos.ranchos} close={(refresh) => { if (refresh) getData(); setedit(null); }} />}
                {edit && section === "ranchos" && <EditorRancho data={edit} close={(refresh) => { if (refresh) getData(); setedit(null); }} />}
            </div>
            {galeriaFiltrosAbierta && <div className='col-lg-12 vw-100 vh-100 blur-s' style={{ zIndex: "999", position: "fixed", top: 0, left: 0, overflow: "auto" }}>
                <div className='row justify-content-center m-0 p-0 w-100'>
                    <CloseButton close={() => setgaleriaFiltrosAbierta(false)} floatElement={false} buttonStyle='bw-200 btn btn-sm btn-danger bg-red3 mt-2 me-2 scale-continue-05 border border-warning border-3 text-bold round-xxl' />
                    <div className="bw p-3 bg-light shadow border round-m" style={{ '--bw': '1200px' }}>
                        <div className='row justify-content-around w-100 m-0 p-0'>
                            <div className='col-lg-12 h4 text-300 text-center mt-3 border-bottom'>SELECCIONE LOS FILTROS QUE DESEA APLICAR</div>
                            {Object.keys(filtrosValulas).map((filtro, i) => (
                                <div key={i} className="bw mt-4" style={{ '--bw': '170px' }}>
                                    <div className='w-100 text-s text-bold ps-1'>{filtro.toUpperCase().replace(/_/g, " ")}</div>
                                    <select className='form-control form-control-sm round-xs shadow sm' value={filtrosValulas[filtro].seleccion} name={filtro} onChange={(e) => filtrarValvulas(e.target.name, e.target.value)}>
                                        <option value='' >SIN FILTRAR</option>
                                        {filtrosValulas[filtro].opciones.map((opcion, j) => <option key={j} value={opcion}>{opcion}</option>)}
                                    </select>
                                </div>
                            ))}
                            <div className='col-lg-12 m-0 p-0 mb-4 mt-5 text-center'>
                                <button className='btn btn-danger bg-red4 text-bold btn-sm bw-400 shadow' onClick={() => {
                                    setfiltrosValulas(prev => {
                                        let nuevo = { ...prev };
                                        Object.keys(nuevo).forEach(k => nuevo[k].seleccion = "");
                                        return nuevo;
                                    });
                                    setdatos(prev => ({ ...prev, valvulas: valulasSinFiltro }));
                                }}>Eliminar filtros</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            <VainillaDialog data={dialog} />
        </>
    )
}

export default CatalogoValvulas;